import React from "react";
import s from "./style.module.css";
import ContentCard from "../ContentCard";

const tags = {
  business: "business",
  consensus: "consensus",
  "covid-19": "covid-19",
  "data protection": "data protection",
  debt: "debt",
  digital: "digital",
  environment: "environment",
  fishing: "fishing",
  gender: "gender",
  governance: "governance",
  india: "india",
  international: "international",
  ownership: "ownership",
  safety: "safety",
  weather: "weather",

  inde: "india",
  dette: "debt",
  genre: "gender",
  // international: "international",
  entreprises: "business",
  météorologie: "weather",
  sécurité: "safety",
  numérique: "digital",
  environnement: "environment",
  // "covid-19": "covid-19",
  propriété: "ownership",
  "protection des données": "data protection",
  gouvernance: "governance",
  // consensus: "consensus",
  pêche: "fishing",

  // india: "india",
  deuda: "debt",
  género: "gender",
  "ámbito internacional": "international",
  empresas: "business",
  clima: "weather",
  seguridad: "safety",
  digitalización: "digital",
  "medio ambiente": "environment",
  // covid-19covid-19": "covid-19",
  propiedad: "ownership",
  "protección de datos": "data protection",
  "gestión institucional": "governance",
  consenso: "consensus",
  pesca: "fishing",
};

const SpotlightsList = ({ items = [] }) => {
  return (
    <div className={s.spotlights}>
      {items.map(({ path, tag, title, content }) => (
        <ContentCard
          key={path}
          alternate
          icon={
            <img
              className={s.icon}
              src={`${process.env.PUBLIC_URL}/images/spotlights/icons/${
                tags[tag.toLowerCase()]
              }.svg`}
              alt=""
            />
          }
          to={path}
          title={tag}
          description={title}
        />
      ))}
    </div>
  );
};

export default SpotlightsList;
